import { render, staticRenderFns } from "./add-investigation-register-form.vue?vue&type=template&id=5ce2b28c&"
import script from "./add-investigation-register-form.vue?vue&type=script&lang=js&"
export * from "./add-investigation-register-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports